import React from 'react';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import '../../styles/Whatsapp.css';

function WhatsappDisplay() {
  return (
    <div className='whatsappMain'>
      {/* Floating WhatsApp Buttons */}
      <div className='whatsAppHover'>
        <a href="https://wa.me/6581338483" target="_blank" rel="noopener noreferrer" className='whatsAppButton'>
          <WhatsAppIcon />
          <span>Jen</span>
        </a>
        <a href="https://wa.me/6588776944" target="_blank" rel="noopener noreferrer" className='whatsAppButton'>
          <WhatsAppIcon />
          <span>Simon</span>
        </a>
      </div>
    </div>
  );
}

export default WhatsappDisplay;
